export const sculpturesDesignData = [
    { id: 1, name: "DRAGON", image: true },
    { id: 2, name: "ELF" },
    { id: 3, name: "BOAT" },
  ];
  